import React from "react";
import {
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import "./PacketTable.scss";

const PacketTable = ({
  packets = [],
  handlePacketSelect,
  selectedPacket,
  level = "intermediate",
}) => {
  const formatTimeOnly = (isoTimestamp) => {
    const date = new Date(isoTimestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: false,
    });
  };

  return (
    <TableContainer className={`packet-table ${level}`}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>No.</TableCell>
            <TableCell>Time</TableCell>
            <TableCell>Scr</TableCell>
            <TableCell>Dst</TableCell>
            <TableCell>Proto</TableCell>
            <TableCell>Length</TableCell>
            <TableCell>Data</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {packets.map((packet, index) => (
            <TableRow
              key={index}
              onClick={() => handlePacketSelect(packet)}
              className={
                selectedPacket?.packetNumber === packet.packetNumber
                  ? "active-row"
                  : ""
              }
            >
              <TableCell>{index + 1}</TableCell>
              <TableCell>{formatTimeOnly(packet.time)}</TableCell>
              <TableCell> {packet.source}</TableCell>
              <TableCell> {packet.dest}</TableCell>
              <TableCell>{packet.proto}</TableCell>
              <TableCell>{packet.length}</TableCell>
              <TableCell>
                <Tooltip
                  title={JSON.stringify(packet.data)}
                  arrow
                  slotProps={{
                    tooltip: { className: "packet-data-tooltip" },
                    popper: { disablePortal: true },
                  }}
                >
                  {JSON.stringify(packet.data).slice(0, 10)}...
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(PacketTable);
